{
  "notification.wallet_topup_confirmed": {
    "title": "Top-up confirmed",
    "body": "Your wallet was topped up by {{amount}} {{currency}}. New balance: {{balance_after}} {{currency}}."
  },
  "notification.invoice_generated": {
    "title": "New invoice ready",
    "body": "Invoice {{invoice_number}} for the period {{period_start}} – {{period_end}} totaling {{total}} {{currency}} is ready to download."
  },
  "notification.withdraw_approved": {
    "title": "Withdrawal approved",
    "body": "Your withdrawal request {{request_id}} of {{amount}} {{currency}} has been approved and queued for transfer."
  },
  "notification.wallet_low_balance": {
    "title": "Low wallet balance",
    "body": "Your wallet balance is now {{balance}} {{currency}}, below the {{threshold}} {{currency}} alert threshold. Top up to keep orders flowing."
  },
  "notification.wallet_low_balance_test": {
    "title": "Test alert — low wallet balance",
    "body": "This is a TEST alert. Your wallet balance would read {{balance}} {{currency}} against the {{threshold}} {{currency}} alert threshold. No action needed."
  },
  "notification.new_topup_request": {
    "title": "New top-up request",
    "body": "Merchant {{merchant_name}} submitted a top-up request {{request_id}} for {{amount}} {{currency}} via {{method}}."
  },
  "notification.new_withdraw_request": {
    "title": "New withdrawal request",
    "body": "Merchant {{merchant_name}} submitted a withdrawal request {{request_id}} for {{amount}} {{currency}}."
  },
  "notification.pending_request_reminder": {
    "title": "Pending requests reminder",
    "body": "{{count}} request(s) have been pending for more than {{hours}} hours. Please review."
  },
  "notification.merchant_credit_overdue": {
    "title": "Merchant credit overdue",
    "body": "Merchant {{merchant_name}} has an overdue balance of {{amount}} {{currency}}, {{days_overdue}} day(s) past due."
  },
  "notification.imap_fail": {
    "title": "IMAP polling failure",
    "body": "Bank IMAP poller {{account}} failed: {{error}}. Last successful poll at {{last_success_at}}."
  },
  "notification.bullmq_dlq_alert": {
    "title": "Job moved to DLQ",
    "body": "Queue {{queue}} sent job {{job_id}} to the dead-letter queue after {{attempts}} attempts. Reason: {{reason}}."
  },
  "notification.auto_recharge_fail": {
    "title": "Auto-recharge failed",
    "body": "Auto-recharge for merchant {{merchant_name}} of {{amount}} {{currency}} failed: {{reason}}. Wallet balance: {{balance}} {{currency}}."
  },
  "notification.auto_pay_batch": {
    "title": "Auto-pay batch processed",
    "body": "Auto-pay batch {{batch_id}} processed {{success_count}}/{{total_count}} invoices totaling {{total}} {{currency}}. {{failed_count}} failures."
  },
  "notification.invoice_sent": {
    "title": "New invoice issued",
    "body": "Invoice {{invoice_number}} ({{amount}} {{currency}}) has been issued. Please review and pay on time."
  },
  "notification.invoice_paid": {
    "title": "Invoice paid",
    "body": "Invoice {{invoice_number}} has been paid {{amount}} {{currency}}. Thank you."
  },
  "notification.invoice_payment_submitted": {
    "title": "New payment awaiting approval",
    "body": "A merchant submitted a payment of {{amount}} {{currency}} for invoice {{invoice_number}} via {{gateway}}. Open the accountant queue to approve or reject."
  },
  "notification.invoice_payment_rejected": {
    "title": "Payment rejected",
    "body": "The payment of {{amount}} {{currency}} for invoice {{invoice_number}} was rejected. Reason: {{reason}}. Please review and resubmit valid proof of payment."
  },
  "notification.credit_memo_issued": {
    "title": "New credit memo issued",
    "body": "You received a credit memo worth {{amount}} USD. The balance can be applied against your next invoice."
  },
  "notification.invoice_overdue": {
    "title": "Invoice overdue by {{days}} day(s)",
    "body": "Invoice {{invoice_number}} is {{days}} day(s) overdue (due date: {{due_date}}). Outstanding balance: {{amount}} {{currency}}. Please pay soon to avoid new-order restrictions."
  },
  "notification.invoice_overdue_final": {
    "title": "Invoice overdue 7 days — final warning",
    "body": "Invoice {{invoice_number}} is {{days}} day(s) overdue (due date: {{due_date}}). Outstanding balance: {{amount}} {{currency}}. Please pay soon to avoid new-order restrictions."
  },
  "notification.credit_expiry_7d": {
    "title": "Your credit expires in 7 days",
    "body": "Your current credit expires in 7 days. Please settle the outstanding balance before the deadline to avoid automatic card lock."
  },
  "notification.credit_expiry_1d": {
    "title": "Credit expires tomorrow",
    "body": "Your current credit expires within the next 24 hours. This is the final reminder — please settle the outstanding balance today."
  },
  "notification.credit_remind_at_amount": {
    "title": "You reached your configured credit threshold",
    "body": "You have used {{used}} of your {{limit}} credit limit, reaching the {{threshold}} reminder threshold you configured."
  },
  "notification.credit_sweep_applied": {
    "title": "Automatic credit sweep",
    "body": "{{amount}} was deducted from your wallet to automatically repay credit debt."
  },
  "notification.crm_attachment_infected": {
    "title": "Attachment flagged as malware",
    "body": "File \"{{filename}}\" has been quarantined. Signature: {{signature}}."
  },
  "notification.order_assigned": {
    "title": "New order assigned",
    "body": "Order {{order_code}} has been assigned to you — open {{link}} to process it."
  },
  "notification.order_paid": {
    "title": "Order paid",
    "body": "Order {{order_code}} has just been paid."
  },
  "notification.order_shipped": {
    "title": "Order shipped",
    "body": "Order {{order_code}} has been handed to the carrier."
  },
  "notification.order_delivered": {
    "title": "Order delivered",
    "body": "Order {{order_code}} has reached the customer."
  },
  "notification.order_cancelled": {
    "title": "Order cancelled",
    "body": "Order {{order_code}} has been cancelled."
  },
  "notification.order_qc_failed": {
    "title": "QC rejected",
    "body": "Vendor reported a QC issue on order {{order_code}}."
  },
  "notification.order_qc_passed": {
    "title": "QC passed",
    "body": "Order {{order_code}} passed QC."
  },
  "notification.order_unpaid_autocancelled": {
    "title": "Order auto-cancelled — unpaid",
    "body": "Order #{{order_id}} was auto-cancelled after {{hours}} hours unpaid. The reserved amount was returned to your wallet. Please recreate the order if still needed."
  },
  "notification.tracking_rts_detected": {
    "title": "Package returned to sender",
    "body": "Order #{{order_id}} was returned to sender by the carrier (tracking {{tracking_number}}). {{item_count}} item(s) affected — review and resolve."
  },
  "notification.order_waiting": {
    "title": "Order awaiting your approval",
    "body": "Order {{orderNumber}} is waiting for your approval before it is sent to production. Review and send it when you're ready."
  },
  "notification.order_auto_pushed": {
    "title": "Order sent to production",
    "body": "Order {{orderNumber}} was automatically sent to production."
  },
  "notification.order_admin_sent": {
    "title": "Order sent to production by support",
    "body": "Order {{orderNumber}} was sent to production on your behalf by our support team."
  },
  "notification.product_published": {
    "title": "Product published",
    "body": "Product {{product_name}} has been published."
  },
  "notification.product_approved": {
    "title": "Product approved",
    "body": "Product \"{{product_name}}\" was approved by the admin and is now Live."
  },
  "notification.product_rejected": {
    "title": "Product rejected",
    "body": "Product \"{{product_name}}\" was rejected by the admin. Reason: {{reason}}"
  },
  "notification.product_sync_failed": {
    "title": "Product sync failed",
    "body": "Product {{product_name}} failed to sync to {{store}}."
  },
  "notification.product_archived": {
    "title": "Product archived",
    "body": "Product {{product_name}} has been archived."
  },
  "notification.store_connected": {
    "title": "Store connected",
    "body": "{{store}} store {{store_name}} is now connected."
  },
  "notification.store_disconnected": {
    "title": "Store disconnected",
    "body": "{{store}} store {{store_name}} needs re-authentication."
  },
  "notification.store_sync_started": {
    "title": "Sync started",
    "body": "Syncing {{count}} products to {{store}}."
  },
  "notification.store_sync_completed": {
    "title": "Sync completed",
    "body": "{{store}} sync finished — {{count}} products."
  },
  "notification.wallet_charged": {
    "title": "Wallet charged",
    "body": "Order {{order_code}} charged {{amount}} from your wallet."
  },
  "notification.wallet_payout_sent": {
    "title": "Payout sent",
    "body": "Payout {{payout_code}} succeeded: {{amount}}."
  },
  "notification.payout_available": {
    "title": "Earnings ready to withdraw",
    "body": "You have {{amount}} available to withdraw — visit {{link}}."
  },
  "notification.auto_pay_retry_exhausted": {
    "title": "Auto-pay retries paused",
    "body": "The system attempted automatic payment several times without success. The order remains pending_payment. Please top up your wallet or pay manually."
  },
  "notification.auto_recharge_disabled": {
    "title": "Auto-recharge paused",
    "body": "The system attempted automatic top-up 3 times (1h / 6h / 24h) without success. Auto-recharge has been disabled — please check your linked payment method and re-enable it manually."
  },
  "notification.invoice_due": {
    "title": "Invoice due soon",
    "body": "Invoice {{invoice_number}} is due in {{days}} day(s)."
  },
  "notification.refund_issued": {
    "title": "Invoice refund",
    "body": "Refund {{amount}} for invoice {{invoice_number}} has been processed."
  },
  "notification.system_maintenance": {
    "title": "Scheduled maintenance",
    "body": "Maintenance at {{time}} — expected downtime {{duration}}."
  },
  "notification.system_release": {
    "title": "New release",
    "body": "{{product}} {{version}} is live — see the changelog."
  },
  "notification.security_alert": {
    "title": "Security alert",
    "body": "A new sign-in from an unrecognized device was detected."
  },
  "notification.kyc_update": {
    "title": "KYC profile needs updating",
    "body": "Your ID document expires in {{days}} days."
  },
  "notification.support_ticket_assigned": {
    "title": "New support ticket assigned",
    "body": "Ticket {{ticketNumber}} ({{category}}) has been assigned to you — open it to respond."
  },
  "notification.support_ticket_force_reassigned": {
    "title": "Support ticket reassigned",
    "body": "Ticket {{ticketNumber}} ({{category}}) was moved back to the unassigned queue and needs a new owner."
  },
  "notification.support_ticket_resolved": {
    "title": "Your support ticket was resolved",
    "body": "Ticket {{ticketNumber}} — {{subject}} has been resolved. Open Support to review or reopen."
  },
  "notification.support_ticket_opened_by_admin": {
    "title": "Support opened a ticket for you",
    "body": "Ticket {{ticketNumber}} — {{subject}}. Open Support to follow up."
  },
  "notification.support_ticket_reply": {
    "title": "New support reply: {{subject}}",
    "body": "{{preview}}"
  },
  "notification.support_ticket_reply_no_subject": {
    "title": "New support reply",
    "body": "{{preview}}"
  },
  "notification.support_ticket_created_for_desk": {
    "title": "New ticket #{{ticketNumber}}: {{subject}}",
    "body": "{{merchantName}} opened a {{category}} ticket. {{preview}}"
  },
  "notification.support_ticket_merchant_reply": {
    "title": "Merchant replied on #{{ticketNumber}}: {{subject}}",
    "body": "{{merchantName}}: {{preview}}"
  },
  "notification.member_landed_no_team": {
    "title": "A new member joined without a team",
    "body": "{{member_name}} accepted the invite, but the team they were invited to was deactivated — they currently belong to no team. Please assign them a team."
  },
  "notification.uat_sample": {
    "title": "[UAT] Sample notification #{{n}} ({{category}})",
    "body": "UAT sweep fixture — {{category}} notification #{{n}} for testing list/pagination/unread badge."
  },
  "support.channel.down": {
    "title": "Support channel down",
    "body": "The {{platform}} channel \"{{name}}\" is disconnected and can no longer receive messages. Reconnect it in Support Configurations."
  },
  "support.bridge.offline": {
    "title": "Bridge device offline",
    "body": "The {{platform}} bridge \"{{name}}\" went offline ({{reason}}) and can no longer send or receive messages. Re-authenticate the bridge to restore it."
  },
  "support.channel.zalo_refresh_failed": {
    "title": "Zalo token refresh failed",
    "body": "Automatic token refresh for the Zalo channel \"{{name}}\" failed after {{attempts}} attempt(s): {{reason}}. Reconnect the channel to restore delivery."
  },
  "support.ticket.reopened_by_merchant": {
    "title": "Merchant reopened a ticket",
    "body": "Merchant reopened ticket {{ticketNumber}}."
  },
  "support.ticket.closed_by_merchant": {
    "title": "Merchant confirmed ticket closure",
    "body": "Merchant confirmed closing ticket {{ticketNumber}}."
  },
  "support.dispatch.created": {
    "title": "New dispatch request",
    "body": "You have a new dispatch request to handle."
  },
  "support.dispatch.handler_reply": {
    "title": "Handling party replied",
    "body": "The handling party posted a message in the dispatch for ticket {{ticketNumber}}."
  },
  "support.dispatch.returned": {
    "title": "Dispatch returned",
    "body": "The handling party returned results for ticket {{ticketNumber}} — please review and close with the merchant."
  },
  "support.dispatch.vendor_reply": {
    "title": "Vendor replied",
    "body": "The vendor posted a message in the dispatch for ticket {{ticketNumber}}."
  },
  "notification.support_ticket_rated": {
    "title": "Ticket rated {{rating}}/5",
    "body": "Ticket {{ticketNumber}} ({{category}}) received a {{rating}}/5 rating from the merchant."
  },
  "notification.support_ticket_rated_low": {
    "title": "Low rating alert: {{rating}}/5",
    "body": "Ticket {{ticketNumber}} ({{category}}) received a low rating ({{rating}}/5) — review the conversation and follow up."
  },
  "notification.support_ticket_resolved_rate": {
    "title": "Your ticket has been resolved",
    "body": "Ticket {{ticketNumber}} ({{category}}) is resolved — let us know how we did by rating the support you received."
  },
  "notification.order_waiting_sla_reminder": {
    "title": "Order awaiting your approval",
    "body": "Order {{order_code}} has been waiting for your approval for {{minutes}} minute(s). Review it and send it to production."
  },
  "vendor_allocation.proposal.created": {
    "title": "New allocation change proposal",
    "body": "{{proposer}} proposed a vendor allocation change awaiting approval. Reason: {{reason}}"
  },
  "vendor_allocation.proposal.approved": {
    "title": "Allocation proposal approved",
    "body": "Your vendor allocation change proposal was approved by {{approver}} and applied to the blueprint."
  },
  "vendor_allocation.proposal.rejected": {
    "title": "Allocation proposal rejected",
    "body": "Your vendor allocation change proposal was rejected by {{approver}}. Reason: {{reason}}"
  },
  "notification.emb_fee_awaiting_accept": {
    "title": "Embroidery fee awaiting approval",
    "body": "Order {{orderNumber}} has an embroidery fee of {{embFee}} awaiting your approval. Respond by {{deadline}}."
  },
  "notification.emb_order_autocancelled_refund": {
    "title": "Order auto-cancelled & refunded",
    "body": "Order {{orderNumber}} was auto-cancelled after the embroidery-fee approval window expired. {{refundAmount}} was refunded to your wallet."
  },
  "notification.pricing_profile_changed": {
    "title": "Pricing profile changed",
    "body": "Your account was moved from {{fromProfile}} to {{toProfile}}. The tag is informational only and does not change your pricing formula."
  },
  "notification.admin_surcharge_debited": {
    "title": "Adjustment surcharge debited from wallet",
    "body": "Order {{orderNumber}}: {{amount}} was debited — reason: {{reason}}."
  },
  "notification.order_confirmed_charged": {
    "title": "Order confirmed",
    "body": "Order {{orderNumber}} is confirmed and {{amount}} was charged from your balance (tax and shipping included)."
  },
  "notification.order_created": {
    "title": "Order created",
    "body": "Order {{order_code}} has been created."
  },
  "notification.order_charge_failed": {
    "title": "Order charge failed",
    "body": "Charging order {{order_code}} failed. Please check your payment method and try again."
  },
  "notification.order_in_production": {
    "title": "Order in production",
    "body": "Order {{order_code}} is now in production."
  },
  "notification.refund_failed": {
    "title": "Refund failed",
    "body": "The refund for order {{order_code}} could not be processed. Our team is looking into it."
  },
  "notification.dispute_opened": {
    "title": "Dispute opened",
    "body": "A dispute was opened for order {{order_code}}. Please review and respond."
  },
  "notification.dispute_evidence_required": {
    "title": "Dispute evidence required",
    "body": "Evidence is required for the dispute on order {{order_code}} before {{deadline}}."
  },
  "notification.dispute_resolved_refund": {
    "title": "Dispute resolved — refund",
    "body": "The dispute on order {{order_code}} was resolved with a refund."
  },
  "notification.dispute_resolved_resend": {
    "title": "Dispute resolved — replacement",
    "body": "The dispute on order {{order_code}} was resolved with a replacement shipment."
  },
  "notification.dispute_resolved_rejected": {
    "title": "Dispute resolved — rejected",
    "body": "The dispute on order {{order_code}} was reviewed and rejected."
  },
  "notification.label_purchased": {
    "title": "Shipping label purchased",
    "body": "A shipping label was purchased for order {{order_code}} (tracking {{tracking_number}})."
  },
  "notification.label_void_failed": {
    "title": "Label void failed",
    "body": "Voiding the shipping label for order {{order_code}} failed."
  },
  "notification.label_rebuy_required": {
    "title": "Shipping label must be re-purchased",
    "body": "The shipping label for order {{order_code}} must be purchased again."
  },
  "notification.label_tracking_stalled": {
    "title": "Tracking has stalled",
    "body": "Tracking for order {{order_code}} ({{tracking_number}}) has not updated recently."
  },
  "notification.embroidery_step2_reminder_24h": {
    "title": "Embroidery fee reminder",
    "body": "Order {{orderNumber}} still has an embroidery fee awaiting your approval — it expires in 24 hours."
  },
  "notification.address_change_requested": {
    "title": "Address change requested",
    "body": "A shipping address change was requested for order {{order_code}}."
  },
  "notification.address_change_confirmed": {
    "title": "Address change confirmed",
    "body": "The shipping address for order {{order_code}} has been updated."
  },
  "notification.address_change_expired": {
    "title": "Address change expired",
    "body": "The address change window for order {{order_code}} expired without confirmation."
  },
  "notification.vendor_rating_dropped": {
    "title": "Vendor rating dropped",
    "body": "The performance rating for vendor {{vendor_name}} dropped below the threshold."
  },
  "notification.vendor_assignment_revoked": {
    "title": "Assignment revoked",
    "body": "The assignment for order {{order_code}} has been revoked."
  },
  "notification.vendor_quality_warning": {
    "title": "Quality warning",
    "body": "A quality warning was issued for vendor {{vendor_name}}."
  },
  "notification.webhook_delivery_exhausted_financial": {
    "title": "Webhook delivery failed",
    "body": "A financial webhook to {{endpoint}} exhausted all retries and was not delivered."
  },
  "notification.webhook_subscription_disabled": {
    "title": "Webhook subscription disabled",
    "body": "The webhook subscription {{endpoint}} was disabled after repeated delivery failures."
  },
  "notification.artwork_ingest_error": {
    "title": "Artwork validation failed",
    "body": "Order {{order_id}} has an artwork issue in area {{area}} ({{error_code}}). Please review and re-upload."
  },
  "notification.affiliate_payout_completed": {
    "title": "Affiliate payout update",
    "body": "There is an update on your affiliate payout {{payout_id}}."
  },
  "notification.vendor_reassignment_needed": {
    "title": "Vendor assignment needs attention",
    "body": "Order {{order_code}} could not be auto-assigned ({{reason}}) — manual reassignment required."
  },
  "notification.account_suspended": {
    "title": "Account suspended",
    "body": "Your account has been suspended. Reason: {{reason}}. Contact support if you believe this is a mistake."
  },
  "notification.account_reactivated": {
    "title": "Account reactivated",
    "body": "Your account has been reactivated. You can now sign in and resume normal operations."
  },
  "notification.blueprint_updated": {
    "title": "Blueprint updated",
    "body": "A blueprint you use has been updated. Please review and re-publish affected products if needed."
  },
  "notification.deal_expiry_warning": {
    "title": "Deal expiring soon",
    "body": "Deal \"{{deal_name}}\" will expire in {{days}} day(s)."
  },
  "notification.embroidery_stitch_count_failed": {
    "title": "Embroidery stitch count failed",
    "body": "Order {{order_id}}, item {{item_id}}: the stitch-count service failed after all retries. Manual review required."
  },
  "notification.invoice_generation_failed": {
    "title": "Invoice generation failed",
    "body": "We could not generate your invoice for the period starting {{period_start}}. Our team has been notified and will retry."
  },
  "notification.routing_pool_empty_merchant_rule": {
    "title": "A merchant routing rule emptied the vendor pool",
    "body": "A routing rule for {{merchantName}} left no eligible vendor for {{variantLabel}} ({{blueprintName}}). {{orderCount}} order(s) are waiting on it. Review that merchant's routing rules to release them."
  },
  "notification.vendor_webhook_delivery_failed": {
    "title": "Webhook delivery failed",
    "body": "We could not deliver {{eventType}} to {{endpoint}} for {{vendorName}} after {{attempts}} attempts. The assignment stays with the vendor — nothing was reassigned. Individual events are never replayed: call GET /assignments and GET /events to catch up."
  },
  "notification.vendor_webhook_auto_disabled": {
    "title": "Webhook endpoint auto-disabled",
    "body": "The webhook endpoint {{endpoint}} for {{vendorName}} was disabled automatically after {{failureCount}} consecutive events failed every delivery attempt. No further events are sent. Re-run the verification handshake on the Integration page to turn it back on, then call GET /assignments and GET /events to catch up."
  },
  "notification.vendor_integration_key_revoked": {
    "title": "API key revoked",
    "body": "The API key {{keyPrefix}} for {{vendorName}} has been revoked. Any request still using it now fails with 401. Create a new key on the Integration page if the integration is still in use."
  },
  "notification.vendor_integration_disabled_by_admin": {
    "title": "API integration turned off by an admin",
    "body": "{{actor}} turned off the API integration for {{vendorName}}. Every API key for this vendor now returns 401 and no webhook events are sent until an admin turns it back on."
  },
  "_vgBindingP18": {
    "title": "vg-binding: P18.D-04 / vg-binding: P18.D-13 / vg-binding: P18.D-36",
    "body": "vg-binding: CONTEXT:decisions=P18.D-04,P18.D-13,P18.D-36 — phase 18 task-06 vendor Integration API notification rows (webhook delivery failed / endpoint auto-disabled / API key revoked / integration disabled by admin), added to en+vi+fr together because assertCatalogComplete() fails the build on a missing locale and tests run I18N_NOTIF_GUARD=strict (a fanout without an i18n_key throws). Not a notification key: absent from NOTIFICATION_KEYS, so lookup() never resolves it."
  },
  "_vgBinding": {
    "title": "vg-binding: CONTEXT:decisions=P17.D-04,P17.D-31,P17.D-43,P17.D-44",
    "body": "vg-binding: INTERFACE-STANDARDS:error-shape — phase 17 task-47 pool-empty admin notification catalog entry, added to en/vi/fr together (assertCatalogComplete fails the build on a missing locale). Not a notification key: absent from NOTIFICATION_KEYS, so lookup() never resolves it."
  }
}
